import { render, staticRenderFns } from "./FormStep1.vue?vue&type=template&id=5aca214e&scoped=true"
import script from "./FormStep1.vue?vue&type=script&lang=js"
export * from "./FormStep1.vue?vue&type=script&lang=js"
import style0 from "./FormStep1.vue?vue&type=style&index=0&id=5aca214e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca214e",
  null
  
)

export default component.exports